import { gql } from "@apollo/client";

export const PACKAGE_QUERIES = {
    GET_ALL_PACKAGES: gql`
      query GetAllPackages($salon_id: ID) {
        getAllPackages(salon_id: $salon_id) {
          success
          message
          packages {
            id
            salon_id
            package_name
            package_description
            salon_service_ids
            salon_services {
              id
              price
              duration
              service {
                  id
                  service_name
              }
            }
            status
            created_at
            updated_at
          }
        }
      }
    `,
};
